import { Layout, CurrentFanbandStats, AlertsSent } from 'components/widgets';
import { QuickPoll } from 'components/containers';
import { usePathIndicator } from 'hooks';
import { ALERT_PROTO_TYPES, LINKS } from 'utils/constants';

export default function QuickPollPage() {
  usePathIndicator(LINKS.quickPoll);

  return (
    <Layout
      sidebar={
        <>
          <CurrentFanbandStats />
          <AlertsSent
            type={ALERT_PROTO_TYPES.survey}
            link={LINKS.quickPollSent.path}
          />
        </>
      }
    >
      <QuickPoll />
    </Layout>
  );
}
